
import { RewardFeatures } from '@/common/reward/types';
import { AppButton, AppCard, AppFormRow, AppInput, AppSelect } from '@/components';
import { useLiveopsMilestoneAdd } from '@/modules/liveops/milestone/model/add';
import { ROUTE_NAME_LIVEOPS } from '@/modules/liveops/router';
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
    name: ROUTE_NAME_LIVEOPS.MILESTONE.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetchLinkableRewards, create, rewardOptions } = useLiveopsMilestoneAdd();

        onMounted(async () => {
            await fetchLinkableRewards();
        });

        return {
            v$,
            model,
            create,
            rewardOptions,
            RewardFeatures
        };
    }
});
